import type { ReactNode, SyntheticEvent } from 'react';
import React from 'react';

import StdDialog from 'components/Dialogs/StdDialog';
import DrawerDialogFrame from 'components/Drawers/DrawerDialogFrame';
import { useStandardDrawerVariant } from 'components/Drawers/StandardDrawer';
import type { RootModalDrawerOptions } from 'components/Drawers/standardDrawerContract';

type Props = {
  children: ReactNode;
  dialogId?: string;
  onClose: (event?: SyntheticEvent, reason?: string) => void;
  rootModalDrawer?: RootModalDrawerOptions;
  title: string;
  [key: string]: unknown;
};

export default function InvestmentTransactionEditSurface({
  children,
  dialogId,
  onClose,
  rootModalDrawer,
  title,
  ...dialogProps
}: Props): React.JSX.Element {
  const isOverlayDrawer = useStandardDrawerVariant() === 'overlay';
  const showDrawerBackButton = Boolean(rootModalDrawer && isOverlayDrawer);

  if (rootModalDrawer) {
    return (
      <DrawerDialogFrame
        title={title}
        onBack={showDrawerBackButton ? onClose : undefined}
        onClose={onClose}
        showBackButton={showDrawerBackButton}
      >
        {children}
      </DrawerDialogFrame>
    );
  }

  return (
    <StdDialog
      {...dialogProps}
      dialogId={dialogId}
      onClose={onClose}
      sharedcomponentid='DIALOG_TYPE_INVESTMENT_TRANSACTIONS_EDIT'
      size='md'
      title={title}
    >
      {children}
    </StdDialog>
  );
}
